<template>
<div class="chapter">
<div class="inner_page">
<p class="P_WFP_ChapHead" id="auto_bookmark_table_of_contents_1"><span>Major Characters in the Novel</span></p>
<p class="P_WFP_DramatisLocation">In Washington</p>
<p class="P_WFP_DramatisText">Edward Montoya Jason of California, President of the United States</p>
<p class="P_WFP_DramatisText">William Abbott, ex-President of the United States</p>
<p class="P_WFP_DramatisText">Mrs. Beth Knox, widow of the Secretary of State</p>
<p class="P_WFP_DramatisText">Representative Harold Knox, their son</p>
<p class="P_WFP_DramatisText">Robert A. Leffingwell, Secretary of State</p>
<p class="P_WFP_DramatisText">Ewan MacDonald MacDonald, Secretary of Defense</p>
<p class="P_WFP_DramatisText">George Henry Wattersill, Attorney General</p>
<p class="P_WFP_DramatisText">Fred Van Ackerman, Senator from Wyoming, Chairman of the Committee on Making Further Efforts for a Russian Truce (COMFORT)</p>
<p class="P_WFP_DramatisText">LeGage Shelby, Chairman of the Defenders of Equality for You (DEFY)</p>
<p class="P_WFP_DramatisText">Rufus Kleinfert, Chairman of the Konference on Efforts to Encourage Patriotism (KEEP)</p>
<p class="P_WFP_DramatisText">Mr. Justice Thomas Buckmaster Davis of the Supreme Court</p>
<p class="P_WFP_DramatisText">Patsy Jason Labaiya, sister of the President</p>
<p class="P_WFP_DramatisText">Robert Durham Munson, Senator from Michigan</p>
<p class="P_WFP_DramatisText">Dolly, his wife</p>
<p class="P_WFP_DramatisText">Tom August, Senator from Minnesota</p>
<p class="P_WFP_DramatisText">Arly Richardson, Senator from Arkansas, Majority Leader of the United States Senate</p>
<p class="P_WFP_DramatisText">Representative J. B. “Jawbone” Swarthman of South Carolina, Speaker of the House</p>
<p class="P_WFP_DramatisText">Representative Bronson Bernard of New York</p>
<p class="P_WFP_DramatisText">Roger P. Croy of Oregon, Vice President of the United States</p>
<p class="P_WFP_DramatisText">Lafe Smith, Senator from Iowa</p>
<p class="P_WFP_DramatisText">Mabel Anderson, widow of Senator Brigham Anderson</p>
<p class="P_WFP_DramatisText">Cullee Hamilton, Senator from California</p>
<p class="P_WFP_DramatisText">Lady Maudulayne</p>
<p class="P_WFP_DramatisText">Celestine Barre</p>
<p class="P_WFP_DramatisText">Walter Dobius, a columnist</p>
<p class="P_WFP_DramatisText">Frankly Unctuous, a commentator</p>
<p class="P_WFP_DramatisText">Other members of the media</p>
<p class="P_WFP_DramatisText">Members of NAWAC (the National Anti-War Activities Congress)</p>
<p class="P_WFP_DramatisLocation">At the United Nations</p>
<p class="P_WFP_DramatisText">Lord Claude Maudulayne, the British Ambassador</p>
<p class="P_WFP_DramatisText">Raoul Barre, the French Ambassador</p>
<p class="P_WFP_DramatisText">Krishna Khaleel, the Ambassador of India</p>
<p class="P_WFP_DramatisText">Nicolai Zworkyan, Ambassador of the U.S.S.R.</p>
<p class="P_WFP_DramatisLocation">In Moscow and Washington</p>
<p class="P_WFP_DramatisText">Vasily Tashikov, Chairman of the Council of Ministers, U.S.S.R.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0006.vue?b6cd5c88